module.exports = __webpack_public_path__ + "img/imagen_todos_indicadores.53c3b365.png";